import { render, staticRenderFns } from "./SugerenciaCurso.vue?vue&type=template&id=0a10f230"
import script from "./SugerenciaCurso.vue?vue&type=script&lang=js"
export * from "./SugerenciaCurso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports